export const userLevels = {
	'GOAL GETTER I': 0,
	'GOAL GETTER II': 1,
	'LEADER I': 3,
	'LEADER II': 4,
	'TRUE LEADER I': 5,
	'TRUE LEADER II': 6,
	PARTNER: 7,
};
